const NBSP = '\u00A0';

/**
 * Bind the last two words of a string with a non-breaking space, so a heading
 * can never wrap with a single word stranded on its final line. When the text
 * fits on one line, or the last two words already share one, nothing changes;
 * the only effect is pulling the second-to-last word down with the last one —
 * e.g. "…Prototyper at" / "Apple." becomes "…Prototyper" / "at Apple."
 */
export const preventOrphan = (text) => {
  if (typeof text !== 'string') return text;

  const words = text.trim().split(/\s+/);
  if (words.length < 3) return text;

  return words.slice(0, -1).join(' ') + NBSP + words[words.length - 1];
};
